import Box from '@risk-smart/themed-cloudscape-components/box';
import ErrorContent from '@risksmart-app/components/src/error-pages/ErrorContent';
import type { FC } from 'react';

/**
 * Shown when a respondent read fails (RSP-6570). Both portal reads previously
 * had no failure surface: the questionnaire list rendered as an empty table
 * ("You have no questionnaires" — indistinguishable from genuinely having none)
 * and the questionnaire form fell through to the `Schema or UISchema is empty`
 * throw, blaming the template for what was a fetch failure. The tRPC branch
 * makes that worse than the Apollo one it replaces: a poll that starts failing
 * mid-session (e.g. 401 after a token expiry) just silently stops updating,
 * where the subscription surfaced a socket drop.
 *
 * Reporting is already handled — the tRPC `QueryCache.onError` reporter
 * (`utils/trpc.ts`) and the Apollo `errorLink` (`data/ApolloGraphqlProvider.tsx`)
 * both send failures to Sentry. This is purely the user-facing half.
 */
export const LoadFailureContent: FC = () => (
  <ErrorContent
    title={'Sorry, we couldn’t load that'}
    imgSrc={'/errors/rubiks-cube.png'}
    imgAlt={'binoculars'}
  >
    <Box variant={'p'}>{'Please try again later'}</Box>
  </ErrorContent>
);
